export default {
    menu: {
        title: 'Meny'
    },
    timePicker: {
        title: 'Velg tid',
        am: 'AM',
        pm: 'PM',
        cancel: 'Avbryt',
        save: 'Bekreft'
    },
    minside: {
        title: 'Velkommen tilbake, {0}'
    },
    errorDialog: {
        title: 'Noe gikk galt',
        close: 'Avbryt',
        reload: 'Last inn siden på nytt',
        subtitle: 'Prøv å laste inn siden på nytt eller å lukke og åpne nettleseren igjen.'
    },
    phoneVerification: {
        recaptchaTokenMissing: 'Recaptcha token mangler. Last siden på nytt og prøv igjen.',
        tooManyRequests: 'For mange forespørsler. Prøv igjen senere.',
        missingParams: 'Mangler parametre. Prøv igjen.',
        requestForPhoneVerificationDefaultError: 'En feil oppsto ved henting av telefonnøkkel. Prøv igjen senere.',
        checkPhoneVerificationCodeDefaultError: 'En feil oppsto ved verifisering av telefonnøkkel. Prøv igjen senere.',
    }
};
